import {
  TextField,
  TextInput,
  NumberInput,
  DateTimeInput,
  SimpleShowLayout,
  useTheme,
  useRecordContext,
} from "react-admin";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import { MyList } from "../ra-lb-tools/components/myList";
import CancelReservationButton from "../components/buttonCancelReservation";
import { Box } from "@mui/material";
import { RecordSummary, MyShow } from "../ra-lb-tools/components/MyShow";
import { LabeledColumn } from "../ra-lb-tools/components/labeledColumn";
import { MyReferenceField } from "../ra-lb-tools/components/myReference";
import { UserField, UserInput } from "./users";
import { MyDateField } from "../ra-lb-tools/components/myDateField";

export const ReservationIcon = EventSeatIcon;

const reservationFilters = () => [
  <NumberInput label="Locker Id" source="lockerId" alwaysOn key={1} />,
  <TextInput label="Tower id" source="locker__tower_id" alwaysOn key={2} />,
  <DateTimeInput label="Canceled" source="canceledAt" key={3} />,
  <DateTimeInput label="Stared after" source="started_at_gt" key={4} />,
  <DateTimeInput label="Expires after" source="expires_at_gt" key={4} />,
  <UserInput source="userId" label="User" allowEmpty alwaysOn key="userId" />,
];

const is_inactive = (record) => record.statusData.id !== 1;

const rowStyle = (record, palette) => {
  return {
    backgroundColor: is_inactive(record)
      ? palette.specialColors.oos
      : palette.background.default,
  };
};

const ReservationStatus = (props) => {
  const record = useRecordContext();

  if (is_inactive(record)) {
    return (
      <Box sx={{ textTransform: "capitalize" }}>{record.statusData.name}</Box>
    );
  }

  return <CancelReservationButton {...props} />;
};

export const ReservationList = (props) => {
  const resource = "reservations";
  const [theme] = useTheme();
  const palette = theme.palette;

  return (
    <MyList
      {...props}
      filters={reservationFilters()}
      resource={resource}
      dataGridProps={{
        rowStyle: (record) => rowStyle(record, palette),
      }}
    >
      <TextField source="id" />
      <MyReferenceField
        source="lockerId"
        reference="lockers"
        link="show"
        label="Locker"
      />
      <MyDateField source="startedAt" showTime />
      <MyDateField source="expiresAt" showTime />
      <MyDateField source="canceledAt" showTime />
      <UserField source="userId" />

      <ReservationStatus />
    </MyList>
  );
};

export const ReservationShow = (props) => {
  return (
    <MyShow {...props}>
      <SimpleShowLayout>
        <RecordSummary>
          <LabeledColumn>
            <TextField source="id" />
            <MyReferenceField
              source="lockerId"
              reference="lockers"
              link="show"
              label="Locker"
            />
            <MyDateField source="startedAt" showTime={true} />
            <MyDateField source="expiresAt" showTime={true} />
            <MyDateField source="canceledAt" showTime={true} />
            <UserField source="userId" />
          </LabeledColumn>
        </RecordSummary>
      </SimpleShowLayout>
    </MyShow>
  );
};
